var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDental = function SvgDental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 3.276c-1.194.766-3.521-1.224-4.868-1.714-5.328-2.021-9.37 3.123-6.4 9.032.705 1.409 1.225 3.98 1.593 6.583.306 2.235.98 6.154 1.96 7.318 1.01 1.163 1.714.122 1.653-1.164-.092-3.061-.123-4.99.673-7.685.704-2.419 4.287-2.419 4.991 0 .796 2.695.765 4.624.674 7.685-.031 1.287.673 2.328 1.653 1.164 1.01-1.164 1.653-5.113 1.96-7.318.367-2.602.857-5.174 1.592-6.583 3-5.91-.061-12.492-8.45-8.236",
    stroke: "#102B3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgDental;